import React from 'react'
import { Box } from '@mui/material'
import { XDecimals } from '../../../types/carbon/models/XDecimals'
import { SettingsNumberInput, SettingsRow } from './SettingsControls'

interface DecimalsSectionProps {
  decimals: XDecimals
  onChange: (decimals: XDecimals) => void
}

const DecimalsSection: React.FC<DecimalsSectionProps> = ({ decimals, onChange }) => {
  const update = (patch: Partial<XDecimals>) => onChange({ ...decimals, ...patch })

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
      <SettingsRow>
        <SettingsNumberInput label="Frequencies" value={decimals.frequencies} onChange={v => update({ frequencies: v })} />
        <SettingsNumberInput label="Percents" value={decimals.percents} onChange={v => update({ percents: v })} />
      </SettingsRow>
      <SettingsRow>
        <SettingsNumberInput label="Statistics" value={decimals.statistics} onChange={v => update({ statistics: v })} />
        <SettingsNumberInput label="Expressions" value={decimals.expressions} onChange={v => update({ expressions: v })} />
      </SettingsRow>
    </Box>
  )
}

export default DecimalsSection
